import useAdProducts from "./useAdProducts";

export default function useAdProductsOfType(type) {
  const { adProducts: allAdProducts, ...queryInfo } = useAdProducts();
  return {
    ...queryInfo,
    adProducts: allAdProducts?.filter((adProduct) => adProduct.type === type),
  };
}
